import brand from '../brand'

// Razorpay Standard Checkout, loaded on demand (only when the customer picks UPI or card).
let scriptPromise = null

export const loadRazorpayScript = () => {
    if (window.Razorpay) return Promise.resolve(true)
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve) => {
            const script = document.createElement('script')
            script.src = 'https://checkout.razorpay.com/v1/checkout.js'
            script.onload = () => resolve(true)
            script.onerror = () => {
                scriptPromise = null // allow a retry
                resolve(false)
            }
            document.body.appendChild(script)
        })
    }
    return scriptPromise
}

// Checkout shows only the method the customer chose: UPI (Google Pay, PhonePe… on phones, a QR code on desktop)
// or card.
const BLOCKS = {
    upi: { name: 'Pay using UPI', instruments: [{ method: 'upi' }] },
    card: { name: 'Pay by credit or debit card', instruments: [{ method: 'card' }] }
}

// Checkout options for a server-created Razorpay order; method is 'upi' or 'card'.
export const checkoutOptions = (order, method, { description, themeColor, onSuccess, onDismiss }) => ({
    key: order.keyId,
    amount: order.amount,
    currency: order.currency,
    order_id: order.orderId,
    name: brand.name,
    description,
    prefill: {
        name: order.name || '',
        email: order.email || '',
        contact: order.contact || ''
    },
    config: {
        display: {
            blocks: { chosen: BLOCKS[method] },
            sequence: ['block.chosen'],
            preferences: { show_default_blocks: false }
        }
    },
    theme: { color: themeColor },
    handler: onSuccess,
    modal: {
        ondismiss: onDismiss,
        confirm_close: true
    }
})
